<!-- eslint-disable vue/no-v-html -->
<template>
	<div id="overview" class="row position-relative">
		<ComponentLoader v-if="!ready" />
		<template v-if="ready">
			<div v-if="hasFilters" class="col-12 col-xl-3">
				<div class="c-filtering">
					<div class="c-filters">
						<div class="c-filters__heading">
							<div class="c-filters__heading--title">
								Kies je filters
							</div>
							<div class="c-filters__heading--closebtn">
								<button class="btn c-filters__heading--btn show" @click="toggleBodyClass('removeClass', 'open-filter')">
									<i class="fal fa-times" />
									<span class="sr-only">Sluiten</span>
								</button>
							</div>
						</div>
						<div class="c-filters__reset">
							<button class="btn btn-link c-filters__reset--btn" @click="resetFacets()">
								<i class="fal fa-undo" />
								<span>Filters resetten</span>
							</button>
						</div>
						<div class="c-filters__items">
							<div v-for="facet in searchSettings.facets" :key="facet.field" :class="['c-filter', { expanded: facet.expanded }]">
								<div class="c-filter__heading" @click="facet.expanded = !facet.expanded">
									<div class="c-filter__title">
										{{ facet.title }}
									</div>
									<div class="c-filter__icon">
										<div class="c-filter__icon--btn c-filter__icon--closed">
											<i class="fal fa-plus" />
										</div>
										<div class="c-filter__icon--btn c-filter__icon--opened">
											<i class="fal fa-minus" />
										</div>
									</div>
								</div>
								<div class="c-filter__body">
									<div class="c-filter__items">
										<div
											v-for="(item, index) in filteredFacets[facet.field]"
											:key="item.value"
											:class="{
												'c-filter__item--hide': !facet.showMore && index + 1 > facet.showMoreAfter
											}"
											class="c-filter__item"
										>
											<div class="custom-control custom-checkbox">
												<input
													:id="facet.field + item.value"
													v-model="checkedFacets"
													:value="facet.field + '|' + item.value"
													:disabled="item.count === 0"
													type="checkbox"
													class="custom-control-input"
													@click="facetClicked()"
												/>
												<label :for="facet.field + item.value" class="custom-control-label">
													<span class="c-filter__item--name">
														{{ item.value }}
													</span>
													<span class="c-filter__item--amount"> ({{ item.count }}) </span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="c-filters__footer">
							<button class="btn btn-secondary btn-block c-filters__footer--button" @click="toggleBodyClass('removeClass', 'open-filter')">
								Toon resultaten
							</button>
						</div>
					</div>
				</div>
			</div>
			<div :class="['col-12', { 'col-xl-9': hasFilters }]">
				<h1 v-if="!asSearchResult" ref="overviewTitle">
					{{ title }}
				</h1>
				<button v-if="hasFilters" class="btn btn-block btn-primary d-flex d-xl-none mb-4" @click="toggleBodyClass('addClass', 'open-filter')">
					<i class="fal fa-sliders-h" />
					<span>Filter {{ count }} resultaten</span>
				</button>

				<div class="c-productoverview">
					<template v-if="itemsWithNetPriceAndQty.length > 0">
						<div class="c-productoverview__options d-none d-xl-flex align-items-center justify-content-between">
							<div class="c-productoverview__amount">
								<strong>{{ count }}</strong
								>&nbsp;artikelen
							</div>
							<div class="c-productoverview__sort">
								<SelectControl
									:value="'' + itemsPerPage"
									codename="Aantal per pagina"
									label="Aantal per pagina"
									:options="[
										{ label: '12', value: '12' },
										{ label: '24', value: '24' },
										{ label: '48', value: '48' },
										{ label: '96', value: '96' }
									]"
									:inline="true"
									class="c-productoverview__sort--select"
									@input="setItemsPerPage($event)"
								/>
								<button type="button" :class="['c-productoverview__sort--list', { active: gridView }]" @click="setGridView(true)">
									<i class="fal fa-th" />
								</button>
								<button type="button" :class="['c-productoverview__sort--list', { active: !gridView }]" @click="setGridView(false)">
									<i class="fal fa-bars" />
								</button>
							</div>
						</div>
						<Pagination v-if="pages > 1" v-model="currentPage" container-class="c-pagination" :page-count="pages" :click-handler="goToPage" page-text="Pagina" from-text="van" next-text="tot" />
						<div class="c c-productoverview__items" :data-view="gridView ? 'grid' : 'list'">
							<div v-for="item in itemsWithNetPriceAndQty" :key="item.CodeName" class="c-productoverview__items--item">
								<Product
									v-if="item.IsWebShopItem == true && item.ModificationCode == 'Confirm'"
									:artikel-nummer="item.Code"
									:artikel-titel="item.ShortDescription"
									:in-stock="true"
									:price="item.GrossPriceInfoPrice"
									:price-promo="item.NetPrice"
									:grid-view="gridView"
									:image-url="item.Image"
									:is-logged-in="isLoggedIn"
									:price-quantity="item.GrossPriceInfoPriceQuantity"
									:price-order-ratio="item.PriceOrderRatio"
									:price-unit-description="item.PriceUnitDescription"
									:price-unit-plural-description="item.PriceUnitPluralDescription"
									:price-unit="item.GrossPriceInfoPriceQuantity > 1 ? item.PriceUnitPluralDescription : item.PriceUnitDescription"
									:hide-price-and-shopping-cart="asSearchResult"
									:is-loading-promo-price="isLoadingPromoPrice"
									:is-loading-warehouse-quantities="isLoadingWarehouseQuantities"
									:quantity-nijverdal="item.QuantityNijv"
									:quantity-zwolle="item.QuantityZw"
									:quantity-ermelo="item.QuantityErme"
									:url-part="item.UrlPart"
								/>
							</div>
						</div>
					</template>
					<div v-else class="c c-productoverview__noresults">
						<slot name="noresults">
							<div class="text">
								<p v-html="noResultsText"></p>
							</div>
						</slot>
					</div>
					<Pagination v-if="pages > 1" v-model="currentPage" :page-count="pages" :click-handler="goToPage" page-text="Pagina" from-text="van" next-text="tot" />
				</div>
			</div>
		</template>
	</div>
</template>
<script>
// import { mapState } from 'vuex'
// import forms from '~/plugins/forms.client.js'
import azuresearch from '../plugins/azureSearch';
import axios from 'axios';
import { setFacets, ConcatFilters, GetFacetFilter } from '../plugins/azureSearch/helpers';
import Pagination from '../components/general/Pagination.vue';
import Product from '../components/general/Product.vue';
import SelectControl from '../components/forms/controls/SelectControl.vue';
import ComponentLoader from '../components/general/ComponentLoader.vue';
export default {
	components: {
		ComponentLoader,
		Pagination,
		Product,
		SelectControl
	},
	props: {
		searchOverviewSettings: {
			type: Object,
			required: true
		},
		categoryTitle: {
			type: String,
			required: false,
			default: ''
		},
		categorySettings: {
			type: Object,
			required: false,
			default: () => {}
		},
		azureSearchIndexName: {
			type: String,
			required: false,
			default: 'test'
		},
		asSearchResult: {
			type: Boolean,
			required: false,
			default: false
		},
		noResultsText: {
			type: String,
			required: false,
			default: 'Er zijn geen resultaten gevonden.'
		},
		isLoggedIn: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			...this.searchOverviewSettings,
			title: this.categoryTitle,
			netPrices: [],
			warehouseQuantities: [],
			isLoadingPromoPrice: false,
			isLoadingWarehouseQuantities: false
		};
	},
	computed: {
		maxPages() {
			// Calculate the amount of pages
			if (this.searchSettings.searchRequest.top === 0) {
				return 0;
			}
			return Math.ceil(this.count / this.searchSettings.searchRequest.top);
		},
		pages() {
			return Math.ceil(this.count / (this.itemsPerPage || this.pageSize));
		},
		hasFilters() {
			if (this.asSearchResult) return false;
			if (this.facets['EtimKenmerken/Facet'].length > 0) {
				return true;
			}
			return false;
		},
		filteredFacets() {
			const facets = Object.assign({}, this.facets);
			for (const key in facets) {
				facets[key] = facets[key]
					.filter(facet => facet.value)
					.sort((a, b) => {
						const numA = Number(a.value?.split('|')[1]?.split(' ')[0]) || Number(a.value?.split(' ')[0]) || '-';
						const numB = Number(b.value?.split('|')[1]?.split(' ')[0]) || Number(b.value?.split(' ')[0]) || '-';

						if (isNaN(numA)) return b.count - a.count;
						else return numA - numB;
					});
			}
			return facets;
		},
		itemsWithNetPriceAndQty() {
			this.items.forEach(item => {
				item.NetPrice = 0;
				item.QuantityNijv = 0;
				item.QuantityZw = 0;
			});
			this.netPrices.length > 0 &&
				this.netPrices.forEach(netPrice => {
					this.items
						.filter(item => item.Code === netPrice.AtricleCode)
						.map(item => {
							item.NetPrice = netPrice.NettoPrijs;
							return item;
						});
				});
			this.warehouseQuantities.length > 0 &&
				this.warehouseQuantities.forEach(Qty => {
					this.items
						.filter(item => item.Code === Qty.AtricleCode)
						.map(item => {
							if (Qty.WareHouseCode === 'NIJV') item.QuantityNijv = Qty.QuantityFree;
							if (Qty.WareHouseCode === 'HK') item.QuantityZw = Qty.QuantityFree;
							if (Qty.WareHouseCode === 'ERME') item.QuantityErme = Qty.QuantityFree;

							return item;
						});
				});
			return this.items;
		}
	},
	watch: {
		checkedFacets(val) {
			this.currentPage = 1;
			this.search();
		}
	},
	created() {
		this.productOverviewClient = axios.create({
			baseURL: '/api/productoverview' // = BasketController
		});
		this.productOverviewClient.defaults.headers.common['Content-Type'] = 'application/json';
		this.productOverviewClient.defaults.timeout = 0;
		this.productOverviewClient.defaults.method = 'post';
		this.searchSettings.apiSettings = {
			apiVersion: '2017-11-11',
			corsSettings: [],
			indexName: 'henk-abp-articles-' + this.azureSearchIndexName,
			searchServiceAdminApiKey: '3E38B7294291D1EEFEB4565B5384F36D',
			searchServiceName: null,
			searchServiceQueryApiKey: '421932712F8217C1C7C50B881E8129A4',
			url: 'https://prod-henk-search.search.windows.net'
		};
		this.searchApi = new azuresearch.AzureSearchApi(this.searchSettings);
	},
	mounted() {
		if (localStorage.itemsPerPage) {
			if (this.itemsPerPage !== localStorage.itemsPerPage) {
				this.itemsPerPage = localStorage.itemsPerPage;
				this.setItemsPerPage(this.itemsPerPage);
			}
		} else {
			this.setItemsPerPage(48);
		}
		if (localStorage.gridView) {
			const gridViewVal = localStorage.getItem('gridView');
			this.gridView = JSON.parse(gridViewVal) === true;
		}
	},
	methods: {
		toggleBodyClass(addRemoveClass, className) {
			const el = document.body;
			if (addRemoveClass === 'addClass') {
				el.classList.add(className);
			} else {
				el.classList.remove(className);
			}
		},
		imageUrl(item) {
			// if (item.Image) return item.Image
			// if (this.categorySettings && this.categorySettings.image) {
			//  return `${this.$config.publicCompanoUrl}${this.categorySettings.image.value}`
			// }
			return null;
		},
		setItemsPerPage(event) {
			localStorage.itemsPerPage = event;
			this.searchSettings.searchRequest.top = event;
			this.searchSettings.pageSize = event;
			this.currentPage = 1;
			this.itemsPerPage = Number(event);
			// this.$store.$router.push({
			//   query: { ...this.$nuxt._route.query, page: 1 }
			// });
			this.search();
		},
		setGridView(event) {
			this.gridView = event;
			localStorage.gridView = event;
		},
		sort(event) {
			// this.$store.dispatch('search/setSortering', event);
			this.searchSettings.searchRequest.orderBy = event;
			this.currentPage = 1;
			this.$store.$router.push({
				query: { ...this.$nuxt._route.query, page: 1 }
			});
			this.search();
		},
		createSearchRequest() {
			const searchRequest = new azuresearch.AzureSearchRequest(this.searchSettings.searchRequest);
			const predefinedfilter = this.searchSettings.searchRequest.filter;
			const facetfilters = GetFacetFilter(this.checkedFacets, this.facetSettings, this.complexFacetParents, this.complexFacetNames);
			const filter = ConcatFilters([predefinedfilter, facetfilters]);
			this.searchSettings.searchRequest.skip = searchRequest.skip = (this.currentPage - 1) * this.searchSettings.searchRequest.top;
			searchRequest.filter = filter;
			searchRequest.orderBy = 'search.score() desc, ShortDescription asc'; // Order by score and then by shortdescription.
			return searchRequest;
		},
		async search(event) {
			const searchRequest = this.createSearchRequest();
			if (event) event.preventDefault();
			await this.executeSearch(searchRequest);
		},
		async getNetPrices(articles) {
			const articleCodes = articles.map(article => article.Code);
			this.isLoadingPromoPrice = true;
			this.productOverviewClient
				.post('/netprices', articleCodes)
				.then(netPrices => {
					this.netPrices = netPrices.data;
					this.isLoadingPromoPrice = false;
				})
				.catch(() => {
					this.isLoadingPromoPrice = false;
				});
		},
		async getWarehouseQuantities(articles) {
			const articleCodes = articles.map(article => article.Code);
			this.isLoadingWarehouseQuantities = true;
			this.productOverviewClient
				.post('/warehousequantities', articleCodes)
				.then(warehouseQuantities => {
					this.warehouseQuantities = warehouseQuantities.data;
					this.isLoadingWarehouseQuantities = false;
				})
				.catch(() => {
					this.isLoadingWarehouseQuantities = false;
				});
		},
		async executeSearch(searchRequest) {
			try {
				const response = await this.searchApi.search(searchRequest);
				this.facets = setFacets(this.facets, response.data['@search.facets'], this.initialSearch, this.checkedFacets);
				this.items = response.data.value;

				// Don't wait for these calls because it can take some time.
				this.getNetPrices(this.items);
				this.getWarehouseQuantities(this.items);
				this.ready = true;
				this.count = response.data['@odata.count'];
				this.initialSearch = false;
				this.setComplexFacets();
			} catch (error) {
				console.log(error);
			}
		},
		setComplexFacets() {
			this.facets = Object.assign({}, this.facets);
			this.complexFacetNames = [];
			this.complexFacetParents = [];
			const complexFacets = this.facetSettings.filter(facetSetting => facetSetting.value === 'Complex');
			// Add complex facets to this.facets
			let complexFieldId = 0;
			for (const complexFacet of complexFacets) {
				const complexFacetValues = this.facets[complexFacet.key];
				for (const complexFacetValue of complexFacetValues) {
					const splittedComplexFacet = complexFacetValue.value.split('|');
					const title = splittedComplexFacet[0];
					const value = splittedComplexFacet[1];
					let fieldName = Object.keys(this.complexFacetNames).find(key => this.complexFacetNames[key] === title);
					if (typeof fieldName === 'undefined') {
						fieldName = `complex${complexFieldId}`;
						complexFieldId++;
					}
					this.complexFacetNames[fieldName] = title;
					this.complexFacetParents[fieldName] = complexFacet.key;
					if (typeof this.facets[fieldName] === 'undefined') {
						this.facets[fieldName] = [];
					}
					const newFacetValue = {
						count: complexFacetValue.count,
						value
					};
					const previousFacetValue = this.facets[fieldName].find(fv => fv.value === newFacetValue.value);
					if (previousFacetValue) {
						previousFacetValue.count = newFacetValue.count;
					} else {
						this.facets[fieldName].push(newFacetValue);
					}
				}
			}
			// Add complex facets to this.searchSettings.facets
			for (const property in this.complexFacetNames) {
				const title = this.complexFacetNames[property];
				const newFacet = {
					title: this.complexFacetNames[property],
					field: property,
					textTop: '',
					textBottom: '',
					tooltipText: '',
					valueType: 0,
					facetMode: 0,
					expanded: true,
					showMore: true,
					showMoreAfter: 5,
					facetValueOverrides: null,
					sliderSettings: null
				};
				const previousFacet = this.searchSettings.facets.find(facet => facet.title === title);
				if (!previousFacet) this.searchSettings.facets.push(newFacet);
			}
			this.complexFacetsLoaded = true;
		},
		goToPage(pageNumber) {
			if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= this.maxPages) {
				this.currentPage = pageNumber;
				this.search();
				const overviewTitle = this.$refs.overviewTitle;
				if (overviewTitle != null) {
					overviewTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}
		},
		isShowMore(showMoreAfter, filteredFacets) {
			if (filteredFacets && filteredFacets.length > showMoreAfter) return true;
		},
		facetClicked() {
			this.filtered = true;
			// this.$scrollTo('#overview');
		},
		resetFacets() {
			this.checkedFacets = [];
		},
		resetAll() {
			this.complexFacetNames = {};
			this.facets = {};
			this.complexFacetParents = [];
			this.checkedFacets = [];
			const complexFacetSettings = this.searchSettings.facets.filter(facet => facet.field.startsWith('complex'));
			for (const complexFacetSetting of complexFacetSettings) {
				const index = this.searchSettings.facets.findIndex(e => e.field === complexFacetSetting.field);
				this.searchSettings.facets.splice(index, 1);
			}
		}
	}
};
</script>
